import { type DialogProps, Dialog, Row, Text } from "@mdotm/shadcn/legacy/components";
import { type SpawnResult, adaptAnimatedNodeProvider, spawn } from "@mdotm/shadcn/legacy/react-extensions";
import { ForEach } from "@mdotm/utils/react-extra";
import { themeCSSVars } from "@mdotm/shadcn/legacy/themes";
import { Link } from "react-router-dom";

export type MultipleChoiceCreationDialogItem = {
	href: string;
	icon: string;
	title: string;
	description: string;
	"data-qualifier": string;
};

export type MultipleChoiceCreationDialogProps = SpawnMultipleChoiceCreationDialogProps &
	Pick<DialogProps, "onAnimationStateChange" | "onClose" | "show">;

export function MultipleChoiceCreationDialog(props: MultipleChoiceCreationDialogProps): React.JSX.Element {
	return (
		<Dialog
			show={props.show}
			size={props.options.length >= 3 ? "large" : props.options.length === 2 ? "medium" : "small"}
			onClose={props.onClose}
			onAnimationStateChange={props.onAnimationStateChange}
		>
			<Row alignItems="stretch" justifyContent="center" gap={16}>
				<ForEach collection={props.options}>
					{(option, index) => (
						<Link
							to={option.href}
							className={`hover:bg-[color:var(--palette-N50)] hover:rounded-md p-4 flex flex-col items-center justify-start`}
							data-qualifier={option["data-qualifier"]}
							onClick={props.onClose}
						>
							<img alt={`Option ${index + 1}`} src={option.icon} className="mx-auto h-20 w-auto" />
							<Text
								color={themeCSSVars.palette_N700}
								as="p"
								className="text-center max-w-[200px] my-1"
								type="Body/XL/Bold"
							>
								{option.title}
							</Text>
							<Text color={themeCSSVars.palette_N700} as="p" className="text-center max-w-[200px]" type="Body/M/Book">
								{option.description}
							</Text>
						</Link>
					)}
				</ForEach>
			</Row>
		</Dialog>
	);
}

type SpawnMultipleChoiceCreationDialogProps = {
	options: [MultipleChoiceCreationDialogItem, ...MultipleChoiceCreationDialogItem[]];
};
export function spawnMultipleChoiceCreationDialog(params: SpawnMultipleChoiceCreationDialogProps): SpawnResult<void> {
	return spawn<void>(
		adaptAnimatedNodeProvider(({ resolve, show, onHidden }) => (
			<MultipleChoiceCreationDialog
				{...params}
				show={show}
				onAnimationStateChange={(state) => state === "hidden" && onHidden()}
				onClose={() => resolve()}
			/>
		)),
	);
}
